var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6133_3112)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.38 15.7C31.38 24.37 24.36 31.4 15.68 31.4C7 31.4 0 24.37 0 15.7C0 7.03 7.03 0 15.69 0C24.35 0 31.39 7.04 31.39 15.7",
    fill: "#00A5D5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.62 25.2704C14.23 25.2704 12.84 25.2804 11.45 25.2704C8.38998 25.2404 5.79998 22.6304 5.78998 19.6004C5.78998 17.0704 5.78998 14.5404 5.78998 12.0104C5.78998 8.75038 8.47998 6.10038 11.78 6.11038C14.35 6.11038 16.92 6.11038 19.49 6.11038C22.83 6.11038 25.59 8.83038 25.59 12.1604C25.59 14.5204 25.58 16.8804 25.59 19.2404C25.62 23.0504 22.27 25.4404 19.53 25.2804C18.23 25.2104 16.92 25.2704 15.61 25.2704M15.64 7.94038C14.23 7.94038 12.82 7.92038 11.41 7.94038C9.52998 7.97038 7.69998 9.65038 7.64998 11.5004C7.57998 14.2304 7.55998 16.9704 7.62998 19.7004C7.68998 21.8004 9.44998 23.4704 11.56 23.5104C14.28 23.5604 17 23.5604 19.71 23.5104C21.88 23.4704 23.57 21.8804 23.63 19.7204C23.7 16.9904 23.69 14.2504 23.62 11.5204C23.57 9.63038 21.8 7.99038 19.89 7.95038C18.48 7.92038 17.07 7.95038 15.66 7.95038",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 20.8C13.47 20.88 10.66 18.98 10.64 15.69C10.62 12.72 13.18 10.43 15.99 10.56C18.44 10.68 20.84 12.76 20.83 15.69C20.82 18.63 18.41 20.86 15.71 20.79M12.46 15.64C12.46 17.48 13.88 18.93 15.7 18.93C17.49 18.93 19.01 17.45 19.02 15.68C19.03 13.89 17.46 12.3 15.71 12.34C13.86 12.38 12.46 13.8 12.46 15.64Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.08 11.6004C20.34 11.6004 19.85 11.0604 19.87 10.3004C19.89 9.62037 20.45 9.07037 21.13 9.09037C21.79 9.11037 22.36 9.68037 22.37 10.3504C22.37 11.0504 21.8 11.6104 21.09 11.6004",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6133_3112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.38,
    height: 31.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.224cbb131bb4c8dba4a313ba13413547.svg";
export { ForwardRef as ReactComponent };